import React from "react";
export default function Footer() {
  return (
    <footer className="Footer">
      <a href="https://github.com/FancySun88/WeatherGuide-app">
        Open-source code
      </a>{" "}
      by Iryna Zhelezniak, 2023
    </footer>
  );
}
